import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Kalkulator.module.scss'

import { Container, Button, Image, ProgressBar, FloatingLabel, Form, Row, Col } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import SimleForm from './SimleForm'

class Kalkulator extends React.Component {

  constructor(props) {
    super(props)

    const kv_1 = 0,
    { kalkulator } = props?.data

    var list = [], dver = false
    kalkulator.map( ( elm, k ) => {
      if( k == kv_1 ) {
        list = elm?.list
        dver = elm?.dver == 1
      }
    })

    this.state = {
      step: 1,
      kv_1: kv_1,
      kv_1_text: kalkulator[kv_1]?.name || '',
      list: list,
      dver: dver,
      kv_2: 0,
      kv_2_text: list[0]?.name || '',
      height: null,
      width: null,
      doorHeight: null,
      doorWidth: null,
      material: props.data?.material[0]?.name || ''
    }
  }

  changeStep = ( step ) => {
    this.setState({
      step: step < 1 ? 1 : ( step > 4 ? 4 : step )
    })
  }

  c_kv_1 = ( k, name ) => {

    const { kalkulator } = this.props.data

    var list = [], dver = false
    kalkulator.map( ( elm, j ) => {
      if( j == k ) {
        list = elm?.list
        dver = elm?.dver == 1
      }
    })

    this.setState({
      kv_1: k,
      kv_1_text: name,
      list: list,
      dver: dver,
      kv_2: 0,
      kv_2_text: list[0]?.name || ''
    })
  }
  c_kv_2 = ( k, name ) => {
    this.setState({
      kv_2: k,
      kv_2_text: name
    })
  }

  handleMaterialChange = (value) => {
    this.setState({
      material: value
    })
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  formatSlideNumber2 = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `${index < 10 ? '0' + index : index}`
  }

  componentDidMount() {
    const { kalkulator } = this.props.data
    window.console.log( kalkulator )
  }

  render() {

    const { data, assets_path } = this.props,
    { step, kv_1, list, dver, kv_2, kv_1_text, kv_2_text, height, width, doorHeight, doorWidth, material } = this.state

    return (
      <section className={`${styles.section}`}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            className={styles.title}
          />
          <div className={styles.kviz}>
            <div className={styles.kviz_top}>
              <div className={styles.kviz_top_text}>
                <Image src={`/${assets_path}/images/calculator.svg`} alt="P" width={18} height={20} />
                <div>Ответьте на вопросы и мы рассчитаем окно под ваше помещение</div>
              </div>
              <div>[{this.formatSlideNumber2(step)}/04]</div>
            </div>
            <ProgressBar className={styles.kviz_progress} now={step / 4 * 100} />
            <div className={styles.kviz_content}>
              {step == 1 &&
                <>
                  <div className={styles.kviz_content_top}>
                    <div className={styles.kviz_content_ttitle}>Выберите тип окна</div>
                    <div>Доступен один из вариантов ответа</div>
                  </div>
                  <div className={styles.kviz_content_items}>
                    {data?.kalkulator.map( ( elm, k ) => (
                      <div
                        onClick={() => this.c_kv_1( k, elm?.name )}
                        className={kv_1 == k ? styles.kviz_content_items_el_active : styles.kviz_content_items_el}
                        key={k}
                      >
                        <div className={styles.kviz_content_items_el_num}>{this.formatSlideNumber(k)}</div>
                        <div className={styles.kviz_content_items_el_image}>
                          <Image src={elm?.image} width={199} height={121} alt={elm?.name} />
                        </div>
                        <div className={styles.kviz_content_items_el_name}>{elm?.name}</div>
                      </div>
                    ))}
                  </div>
                </>
              }
              {step == 2 &&
                <>
                  <div className={styles.kviz_content_top}>
                    <div className={styles.kviz_content_ttitle}>Выберите тип открытия окна</div>
                    <div>Доступен один из вариантов ответа</div>
                  </div>
                  <div className={styles.kviz_content_items}>
                    {list.map( ( elm, k ) => (
                      <div
                        onClick={() => this.c_kv_2( k, elm?.name )}
                        className={kv_2 == k ? styles.kviz_content_items_el_active : styles.kviz_content_items_el}
                        key={k}
                      >
                        <div className={styles.kviz_content_items_el_num}>{this.formatSlideNumber(k)}</div>
                        <div className={styles.kviz_content_items_el_image}>
                          <Image src={elm?.image} width={199} height={121} alt={elm?.name} />
                        </div>
                        <div className={styles.kviz_content_items_el_name}>{elm?.name}</div>
                      </div>
                    ))}
                  </div>
                </>
              }
              {step == 3 &&
                <>
                  <div className={styles.kviz_content_top}>
                    <div className={styles.kviz_content_ttitle}>Укажите высоту и ширину окна</div>
                    <div />
                  </div>
                  <div className={styles.kviz_content_selects}>
                    <Row>
                      <Col lg={6}>
                        <FloatingLabel 
                          controlId="floatingHeight" 
                          label="Высота окна (мм)" 
                          className="mb-3"
                        >
                          <Form.Control 
                            type="number" 
                            placeholder="Высота окна" 
                            value={height || ''}
                            onChange={(e) => this.setState({ height: e.target.value })}
                          />
                        </FloatingLabel>
                      </Col>
                      <Col lg={6}>
                        <FloatingLabel 
                          controlId="floatingWidth" 
                          label="Ширина окна (мм)" 
                          className="mb-3"
                        >
                          <Form.Control 
                            type="number" 
                            placeholder="Ширина окна" 
                            value={width || ''}
                            onChange={(e) => this.setState({ width: e.target.value })}
                          />
                        </FloatingLabel>
                      </Col>
                    </Row>
                    {dver &&
                      <Row>
                        <Col lg={6}>
                          <FloatingLabel 
                            controlId="floatingDoorHeight" 
                            label="Высота двери (мм)" 
                            className="mb-3"
                          >
                            <Form.Control 
                              type="number" 
                              placeholder="Высота двери" 
                              value={doorHeight || ''}
                              onChange={(e) => this.setState({ doorHeight: e.target.value })}
                            />
                          </FloatingLabel>
                        </Col>
                        <Col lg={6}>
                          <FloatingLabel 
                            controlId="floatingDoorWidth" 
                            label="Ширина двери (мм)" 
                            className="mb-3"
                          >
                            <Form.Control 
                              type="number" 
                              placeholder="Ширина двери" 
                              value={doorWidth || ''}
                              onChange={(e) => this.setState({ doorWidth: e.target.value })}
                            />
                          </FloatingLabel>
                        </Col>
                      </Row>
                    }
                    <FloatingLabel controlId="floatingSelect1" label="Материал" className="mt-2">
                      <Form.Select 
                        aria-label="Материал"
                        value={material}
                        onChange={(e) => this.handleMaterialChange(e.target.value)}
                      >
                        {data?.material.map( ( elm, k ) => (
                          <option key={k} value={elm?.name}>{elm?.name}</option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </div>
                </>
              }
              {step == 4 &&
                <>
                  <div className={styles.kviz_content_top}>
                    <div className={styles.kviz_content_ttitle}>Рассчитать стоимость выбранной комплектации</div>
                    <div />
                  </div>
                  <div className={styles.kviz_content_form}>
                    <SimleForm
                      btn={`Узнать стоимость окна`}
                      assets_path={assets_path}
                      width={233}
                      name={true}
                      data={[
                        { name: 'Тип окна', value: kv_1_text },
                        { name: 'Тип открытия окна', value: kv_2_text },
                        { name: 'Высота окна', value: height ? `${height} мм` : '' },
                        { name: 'Ширина окна', value: width ? `${width} мм` : '' },
                        { name: 'Высота двери', value: doorHeight ? `${doorHeight} мм` : 'Не указано' },
                        { name: 'Ширина двери', value: doorWidth ? `${doorWidth} мм` : 'Не указано' },
                        { name: 'Материал', value: material }
                      ]}
                    />
                  </div>
                </>
              }
            </div>
            <div className={styles.kviz_bottom}>
              <Button onClick={() => this.changeStep( step - 1 )} className={styles.kviz_bottom_btn} variant={`light`}>
                <div className={styles.kviz_bottom_btn_icon}>
                  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.3211 4.49913H1.6787M1.6787 4.49913L5.53564 8.35608M1.6787 4.49913L5.53564 0.642184" stroke="black" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className={styles.kviz_bottom_btn_text}>Назад</div>
              </Button>
              <Button onClick={() => this.changeStep( Number(step) + 1 )} className={styles.kviz_bottom_btn} variant={`light`}>
                <div className={styles.kviz_bottom_btn_icon}>
                  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.678756 4.50087H10.3211M10.3211 4.50087L6.46418 0.643924M10.3211 4.50087L6.46418 8.35782" stroke="#00C775" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className={styles.kviz_bottom_btn_text}>Вперед</div>
              </Button>
            </div>
          </div>
        </Container>
      </section>
    )
  }
}

Kalkulator.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string
}

Kalkulator.defaultProps = {
  data: {},
  assets_path: ``
}

export default Kalkulator